<div
    class="flex h-full w-full min-w-0 flex-col items-stretch justify-start space-y-5 overflow-hidden">

    <div class="flex-0 flex w-full min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex min-w-0 flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <!-- <atom-back-button (clicked)="backToBriefs()" /> -->

            <button (click)="backToBriefs()" type="button" class="fab-button-secondary shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>

            <div class="min-w-0">
                <div class="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
                    <h3 class="text-md font-semibold text-primary">{{ manageBriefTabsService.focussedBrief() ?
                        manageBriefTabsService.focussedBrief()!.title : 'Loading...'
                        }}
                    </h3>
                    @if (manageBriefTabsService.isShoutPlusBrief()) {
                    <img src="assets/images/plus/SHOUT_plus_logo_full_colour_black_regular.png" alt=""
                        class="h-7 w-auto shrink-0 dark:hidden" aria-hidden="true">
                    <img src="assets/images/plus/SHOUT_plus_logo_white_regular.png" alt=""
                        class="hidden h-7 w-auto shrink-0 dark:block" aria-hidden="true">
                    }
                    <span
                        class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ring-opacity-20"
                        [class]="getBadgeColour()">{{
                        getPostType()
                        }}</span>

                    @if (manageBriefTabsService.focussedBrief() &&
                    manageBriefTabsService.focussedBrief()!.shoutBrief?.resultsVersion ===
                    SubmittedPostVersionEnum.UltraSocial) {
                    <span
                        class="inline-flex items-center rounded-full bg-pink-50 px-1.5 py-0.5 text-xs font-medium text-pink-700 inset-ring inset-ring-pink-700/10 dark:bg-pink-900/20 dark:text-pink-400 dark:inset-ring-pink-400/20 ring-1 ring-pink-600 dark:ring-pink-400/20">ULTRA</span>
                    }
                    @if (manageBriefTabsService.getAffiliateProviderLogo(themeService.isDarkMode()); as affiliateLogo) {
                    <img [src]="affiliateLogo"
                        [alt]="manageBriefTabsService.getAffiliateProviderLabel() || 'Affiliate partner logo'"
                        class="w-20 shrink-0 object-contain" />
                    }
                </div>
                <p class="mt-0 text-xs text-secondary">Manage Brief</p>
            </div>
        </div>


        <div class="flex min-w-0 w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center sm:justify-end sm:gap-x-4">
            <div class="min-w-0">
                <nav aria-label="Tabs" class="flex min-w-0 gap-2 overflow-x-auto scrollbar-transparent">
                    <a [routerLink]="manageBriefTabLink(BriefProgressEnum.ActivityFeed)"
                        class="shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(BriefProgressEnum.ActivityFeed)">Activity Feed</a>
                    <a [routerLink]="manageBriefTabLink(BriefProgressEnum.Briefing)"
                        class="shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(BriefProgressEnum.Briefing)">Briefing</a>
                    <a [routerLink]="manageBriefTabLink(BriefProgressEnum.Assignment)"
                        class="shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(BriefProgressEnum.Assignment)">Assignment</a>
                    <a [routerLink]="manageBriefTabLink(BriefProgressEnum.ApprovedContent)"
                        class="shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(BriefProgressEnum.ApprovedContent)">Approved Content
                        @if (approvedContentCount()) {
                        <span class="ml-1.5 rounded-full bg-[#db24bf]/10 px-1.5 py-px text-[11px] font-bold tabular-nums text-[#8c167a] dark:text-[#f062dc]"
                            [attr.aria-label]="approvedContentCount() + ' approved videos'">{{ approvedContentCount() }}</span>
                        }</a>
                    @if (isDeliveryBrief()) {
                    <a [routerLink]="manageBriefTabLink(BriefProgressEnum.Logistics)"
                        class="shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(BriefProgressEnum.Logistics)">Logistics</a>
                    }
                    <!-- <a (click)="selectedTab.set(BriefProgressEnum.Moderation)"
                            class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                            [class]="getTabClass(BriefProgressEnum.Moderation)">Moderation</a> -->
                    @if (showsReportingTab()) {
                    <a [routerLink]="manageBriefTabLink(BriefProgressEnum.Reporting)"
                        class="shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(BriefProgressEnum.Reporting)">Reporting</a>


                    <!-- Boost - TikTok -->
                    @if (showsTikTokAdsTabs()) {
                    <a *appHasRole="[77]" [routerLink]="manageBriefTabLink(BriefProgressEnum.SparkAdsV3)"
                        class="shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(BriefProgressEnum.SparkAdsV3)">Ads</a>

                    <!-- Legacy Spark Ads tab; removed once the new Ads tab is signed off. -->
                    <a *appHasRole="[77]" [routerLink]="manageBriefTabLink(BriefProgressEnum.BoostTikTokV2)"
                        class="shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(BriefProgressEnum.BoostTikTokV2)">Spark Ads</a>

                    <a *appHasRole="[77]" [routerLink]="manageBriefTabLink(BriefProgressEnum.TikTokOneReporting)"
                        class="shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(BriefProgressEnum.TikTokOneReporting)">Performance</a>
                    }
                    <!-- Boost - TikTok - END-->


                    <!-- Boost - Meta -->
                    <!-- Coming Soon -->
                    <!-- Boost - Meta - END-->

                    <!-- <a [routerLink]="manageBriefTabLink(BriefProgressEnum.Retro)"
                        class="shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(BriefProgressEnum.Retro)">Retro</a> -->
                    }

                </nav>
            </div>

            <!-- Divider -->
            <div class="hidden h-8 border border-gray-200 dark:border-gray-700 rounded-md sm:block"></div>

            <div class="flex shrink-0 flex-row items-center justify-end gap-x-2">

                @if (getAutoPilotEnabled()) {
                <span (click)="alertAutoPilotOff()"
                    class="auto-pilot-badge text-[10px] sm:text-xs hover:cursor-pointer">
                    <svg class="h-1.5 w-1.5 fill-cyan-600 dark:fill-cyan-400" viewBox="0 0 6 6" aria-hidden="true">
                        <circle cx="3" cy="3" r="3" />
                    </svg>
                    Auto Pilot Enabled
                </span>
                } @else {
                <!-- <button (click)="choosePlanService.autoPilotModalOpen.set(manageBriefTabsService.focussedBrief()!.id!)"
                    type="button" class="inline-flex items-center gap-x-1.5 rounded-md auto-pilot-button">
                    Auto Pilot

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="-mr-0.5 size-5">
                        <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
                        <path
                            d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09" />
                        <path
                            d="M9 12a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2z" />
                        <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 .05 5 .05" />
                    </svg>
                </button> -->
                }

                <el-select name="selected" value="published">
                    <button type="button" class="fab-button-secondary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path
                                d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915" />
                            <circle cx="12" cy="12" r="3" />
                        </svg>
                    </button>

                    <el-options anchor="bottom end" popover
                        class="overflow-auto shadow-md scrollbar-transparent w-96 origin-top-right divide-y divide-border rounded-md bg-card outline-1 -outline-offset-1 outline-border [--anchor-gap:--spacing(2)] data-leave:transition data-leave:transition-discrete data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0">
                        @for (option of briefSettingsOptions; track option.id) {
                        @if (showSettingsOption(option)) {
                        <el-option [value]="option.id" (click)="selectSettingsOption(option)"
                            class="group/option block cursor-pointer p-3 text-sm text-primary select-none focus:bg-zinc-100 focus:text-primary dark:focus:bg-zinc-800 dark:focus:text-white focus:outline-hidden">
                            <div class="flex items-start gap-3">
                                <span
                                    class="mt-0.5 inline-flex size-8 shrink-0 items-center justify-center rounded-md bg-zinc-100 text-primary dark:bg-zinc-800 dark:text-zinc-200 group-focus/option:bg-zinc-200 dark:group-focus/option:bg-zinc-700"
                                    aria-hidden="true">
                                    @switch (option.icon) {
                                    @case ('private') {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-4">
                                        <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                    </svg>
                                    }
                                    @case ('public') {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-4">
                                        <circle cx="12" cy="12" r="10" />
                                        <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                                        <path d="M2 12h20" />
                                    </svg>
                                    }
                                    @case ('cancelInvites') {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-4">
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                        <circle cx="9" cy="7" r="4" />
                                        <line x1="17" x2="22" y1="8" y2="13" />
                                        <line x1="22" x2="17" y1="8" y2="13" />
                                    </svg>
                                    }
                                    @case ('declineAll') {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-4">
                                        <circle cx="12" cy="12" r="10" />
                                        <path d="m15 9-6 6" />
                                        <path d="m9 9 6 6" />
                                    </svg>
                                    }
                                    @case ('unhireAll') {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-4">
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                        <circle cx="9" cy="7" r="4" />
                                        <line x1="22" x2="16" y1="11" y2="11" />
                                    </svg>
                                    }
                                    @case ('complete') {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-4">
                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                        <path d="m9 11 3 3L22 4" />
                                    </svg>
                                    }
                                    @case ('hireMessage') {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-4">
                                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                    </svg>
                                    }
                                    }
                                </span>
                                <div class="min-w-0 flex-1 flex flex-col">
                                    <p
                                        class="m-0 text-primary font-normal group-aria-selected/option:font-semibold in-[el-selectedcontent]:font-semibold group-focus/option:text-primary dark:group-focus/option:text-white">
                                        {{ option.title }}</p>
                                    <p
                                        class="m-0 mt-1 text-secondary text-xs group-focus/option:text-secondary dark:group-focus/option:text-zinc-300 in-[el-selectedcontent]:hidden">
                                        {{ option.description }}</p>
                                </div>
                            </div>
                        </el-option>
                        }
                        }
                    </el-options>
                </el-select>

                @if (manageBriefTabsService.hasShoutPlusAffiliateResults()) {
                <button type="button" class="btn-shout btn-shout-sm btn-shout-plus-gradient"
                    (click)="launchShoutPlusBriefResults()">
                    <img src="assets/images/plus/SHOUT_plus_icon_white.svg" alt="" class="-ml-0.5 h-4 w-auto shrink-0"
                        role="presentation">
                    Results
                </button>
                }
            </div>

        </div>
    </div>


    <!-- Main Tabbed Section -->
    <div class="mbt-tab-panel h-full min-h-0 min-w-0 flex-1 flex flex-col w-full overflow-hidden">
        @if (briefService.focussedBriefSignal()) {
        @switch (selectedTab()) {
        @case (BriefProgressEnum.Briefing) {
        <mbt-briefing (inTabNav)="goToTab($event)"></mbt-briefing>
        }
        @case (BriefProgressEnum.Assignment) {
        <mbt-assignment class="h-full min-h-0" [selectedSubTab]="selectedSubTab()"
            (goToLogistics)="onGoToLogistics($event)"></mbt-assignment>
        }
        @case (BriefProgressEnum.ApprovedContent) {
        <mbt-approved-content></mbt-approved-content>
        }
        <!-- @case (BriefProgressEnum.Moderation) {
        <mbt-moderation></mbt-moderation>
        } -->
        @case (BriefProgressEnum.Logistics) {
        <mbt-logistics></mbt-logistics>
        }
        @case (BriefProgressEnum.Reporting) {
        <mbt-reporting class="h-full min-h-0"></mbt-reporting>
        }
        @case (BriefProgressEnum.TikTokOneReporting) {
        <mbt-reporting-tto></mbt-reporting-tto>
        }
        @case (BriefProgressEnum.Retro) {
        <!-- <mbt-retro [focussedBrief]="briefService.focussedBriefSignal()!"></mbt-retro> -->
        <mbt-retro-v2 [focussedBrief]="briefService.focussedBriefSignal()!"></mbt-retro-v2>
        }
        @case (BriefProgressEnum.ActivityFeed) {
        <mbt-activity-feed (goToTab)="goToTab($event)" (refreshBriefOut)="refreshBrief()"></mbt-activity-feed>
        }
        @case (BriefProgressEnum.BoostTikTokV2) {
        <mbt-boost-tiktok-v2></mbt-boost-tiktok-v2>
        }
        @case (BriefProgressEnum.SparkAdsV3) {
        <mbt-spark-ads></mbt-spark-ads>
        }
        }
        } @else {
        <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
            <div class="h-full w-full flex flex-col items-center justify-center">
                <div class="text-center">
                    <svg aria-hidden="true"
                        class="mx-auto w-12 h-12 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor" />
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill" />
                    </svg>
                    <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">Loading...</h3>
                    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Loading selected brief...</p>
                </div>

            </div>
        </div>
        }
    </div>
</div>

<!-- The hirer accepts or drops offered channels before the wallet is reserved. Every other
     hire happens in the Assignment tab's creator side panel. -->
@if (centralManagement.isItemisedHireOpen() && centralManagement.hireAsksToAcceptChannels()) {
<mb-review-application (close)="centralManagement.isItemisedHireOpen.set(false)"></mb-review-application>
}

@if (briefService.showPromoteToBriefDrawer()) {
<app-promote-to-brief (close)="briefService.showPromoteToBriefDrawer.set(false)"></app-promote-to-brief>
}

@if (magicSearchService.portfolioCreatorId()) {
<cc-creator-profile [creator]="magicSearchService.portfolioCreator()!"
    [showDeliveryAddress]="showDeliveryAddress()"></cc-creator-profile>
}

@if (choosePlanService.autoPilotModalOpen()) {
<app-choose-auto-pilot [briefId]="choosePlanService.autoPilotModalOpen() || ''"
    (refreshBriefOut)="refreshBrief()"></app-choose-auto-pilot>
}
